import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from "@mui/material";
import { useNavigate } from 'react-router-dom';

interface Props {
    url: string
}

export const Back = ({ url }: Props) => {
    const navigate = useNavigate();

    const onBack = () => {
        navigate(url);
    }

    return (
        <IconButton color="primary" aria-label="edit" onClick={onBack}>
            <ArrowBackIcon sx={{ fontSize: 30 }} />
        </IconButton>
    )
}
